import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMutation } from '@tanstack/react-query'
import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import IcaewModalHeader from '@/components/modals/IcaewModals/components/IcaewModalHeader'
import { useIcaewModals } from '@/components/modals/IcaewModals/hooks/useIcaewModals'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import { useCreateStateMutation } from '@/hooks/useCreateStateMutation'
import { useRefreshSessionMetadataMutation } from '@/hooks/useRefreshSessionMetadataMutation'
import { STATE_KEY, STATE_TYPE } from '@/lib/constants'
import { faArrowRight } from '@/lib/fontAwesomePro/regular'

const IcaewPricingModal: React.FC = () => {
  const createStateMutation = useCreateStateMutation()
  const refreshSessionMetadataMutation = useRefreshSessionMetadataMutation()
  const { recordStepCompletion } = useIcaewModals()

  const recordInteractionMutation = useMutation({
    mutationFn: () =>
      createStateMutation.mutateAsync({
        stateKey: STATE_KEY.hasInteractedWithIcaewPricingModal,
        stateValue: true,
        stateType: STATE_TYPE.companyUser,
      }),
    onSuccess: async () => {
      await refreshSessionMetadataMutation.mutateAsync()
      recordStepCompletion()
    },
  })

  function handleHide() {
    recordInteractionMutation.mutate()
  }

  const isHiding = recordInteractionMutation.isPending

  return (
    <Dialog open onHide={handleHide}>
      <DialogContent>
        <IcaewModalHeader>Discounted pricing for ICAEW firms</IcaewModalHeader>

        <DialogBody>
          <p className="text-md mb-4">
            Good news! Because you're an ICAEW-regulated firm, you can use RQ
            for free.
          </p>

          <div className="mb-4 line-through" style={{ fontSize: '18px' }}>
            Standard price: Starting at £199/month.
          </div>

          <div className="text-black" style={{ fontSize: '24px' }}>
            ICAEW-regulated firms:{' '}
            <span className="text-success">£0/month</span>
          </div>
        </DialogBody>

        <DialogFooter>
          <ActionButton
            variant="primary"
            isProcessing={isHiding}
            showIsProcessingText={false}
            onClick={handleHide}
            size="lg"
          >
            Continue
            <FontAwesomeIcon icon={faArrowRight} />
          </ActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default IcaewPricingModal
